import { withStyles } from "@material-ui/core/styles";
import React from "react";
import Component from "src/components/Component";
import Page from "src/components/Page";
import withAppContext from "src/components/withAppContext";
import withAxios from "src/components/withAxios";
import { withSchoolContext } from "../../DirectorPage";
import { styles } from "./styles";
import { IDirectorPurchaseState, IProps } from "./types";
import LoadingSpinner from "src/components/LoadingSpinner";
import AgreementComponent from "src/components/agreementModal";

export default withAppContext(
    withSchoolContext(
        withStyles(styles)(
            withAxios(

                class extends Component<IProps, IDirectorPurchaseState> {
                    public readonly state = this.buildState({
                        loader: false,
                        upgradeDetails: {},
                        paymentDetails: {},
                        openAgreement: false,
                        paymentMethodType: 0,
                        isAgree: false,
                        subscriptionPlan: {},
                        showMessage: false,
                        urlType: '',
                        oldPlanDetails: {},
                        showUpgradeAlert: false,
  upgradeAlertMessage: "",

                    });
                    public handlePopState: (event: any) => void;
                    public componentDidMount() {


                       
                        this.getUpgradeDetails()
                    }
                    public componentWillUnmount() {
                        // Cleanup if needed
                    }
                    public getUpgradeDetails = () => {
                        const storedObject: string = localStorage.getItem("upgradeDetails") || '{}';  // Fallback to an empty object string
                        const parsedObject = JSON?.parse(storedObject);
                        
                        const oldPlanObject: string = localStorage.getItem("oldplandetails") || '{}';
                        const parsedOldPlan = JSON?.parse(oldPlanObject);
                        
                        if (Object.keys(parsedObject).length > 0) {
                            const typeValue = parsedObject?.type || '';
                            this.setState({ 
                                upgradeDetails: parsedObject, 
                                urlType: typeValue,
                                oldPlanDetails: parsedOldPlan 
                            }, () => {
                                this.getAllPlanHandler()
                            })
                        }
                    }

                    public openAgreementModal() {
                        this.setState({ openAgreement: true })
                    }
                    public closeAgreementModal() {
                        this.setState({ openAgreement: false })
                    }

                    public paymentMethodsType(id: any) {
                        this.setState({ paymentMethodType: id })

                    }

                    public async getAllPlanHandler() {
                        this.setState({ loader: true })
                        setTimeout(() => {
                            this.setState({ showMessage: true });
                          }, 3000);
                        const planId: any = this.state.upgradeDetails?.plan?.id
                        const addonPlan = this.state.upgradeDetails?.addon?.length > 0 ? this.state.upgradeDetails?.addon.map((itm: any) => itm.id) : []
                        // const membershipId = this.state.upgradeDetails?.memberShipId || ""
                        const addonId: any = addonPlan || []
                        const paymentData = {
                            // "payment_method":"cheque",
                            "plan_id": planId,
                            "addon_id": addonId,
                            "membership_id":  this.state?.upgradeDetails?.membership_id || "",
                        }
                        const res: any = await this.buildPost(this, "payment/planPayNow")(paymentData)
                        if (res.status && Object.keys(res?.data)?.length > 0) {
                            console.log("res?.data=========>", res?.data)
                            this.setState({ paymentDetails: { ...res?.data, addon: res?.data?.addon == null ? [] : res?.data?.addon, plan: res?.data?.plan != null ? res?.data?.plan : {} } }, () => {
                                console.log("paymentDetails======>", this.state.paymentDetails)
                            })
                            this.setState({ loader: false })
                        } else {
                            this.setState({ loader: false })
                        }

                    }

                    public TwoDecimalFloat(amount: any) {
                        const valueAnount = amount;
                        const roundedNumber = valueAnount.toFixed(2);
                        return roundedNumber

                    }

                    public acceptAgreement(pdfFile: any) {
                        this.setState({ isAgree: true })
                        this.setState({ upgradeDetails: { ...this.state.upgradeDetails, agreement: pdfFile } }, () => {
                            localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));
                        })
                        if (this.state.paymentMethodType === 1) {
                            if ("memberShipId" in this.state.upgradeDetails && this.state.upgradeDetails?.memberShipId) {
                                this.paybyRenewPlanCheck()
                            } else {
                                this.paybyCheck()
                            }

                        }
                        if (this.state.paymentMethodType === 2) {
                            if ("memberShipId" in this.state.upgradeDetails && this.state.upgradeDetails?.memberShipId&& !this.state.upgradeDetails?.onlyBuyAddon) {
                                this.paybyRenewPlanStripe()
                            } else {
                                // alert("only addon stripe")
                                this.paybyStripeMethod()
                            }

                        }
                        //  this.props.history.push("")

                    }

                    public async paybyCheck() {
                        const {
                            appContext: { user },

                        } = this.props;
                        this.setState({ loader: true })
                        const paymentData = {
                            "plan_id": this.state?.upgradeDetails?.plan?.id || "",
                            "school_id": this.props.school.id,
                            "user_id": user.id,
                            "addon_id": this.state?.upgradeDetails?.addonId?.length > 0 ? this.state?.upgradeDetails?.addonId : []
                        }
                        const formData: any = new FormData();
                        formData.append('user_id', user.id);
                        formData.append('school_id', this.props.school.id);
                        formData.append('membership_id', this.state?.upgradeDetails?.membership_id || ""  );
                        formData.append('plan_id', this.state?.upgradeDetails?.plan?.id || "");
                        if (this.state?.urlType) {
                            formData.append('type', 'addon');
                        }
                        // data.append('addon_id[]', '2');
                        formData.append('agreements', this.state?.upgradeDetails?.agreement);
                        if (paymentData?.addon_id?.length > 0) {
                            paymentData?.addon_id.map((item: any) => {
                                formData.append('addon_id[]', item);
                            })

                        }
                        const res: any = await this.buildPost(this, "payment/planUpgradeCheque")(formData)
                        console.log("res------->", res)
                        if (res.status && Object.keys(res?.data)?.length > 0) {
                            this.setState({ upgradeDetails: { ...this.state.upgradeDetails, paymentRes: res } }, () => {
                                localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));
                            })
                            this.setState({ loader: false }, () => {
                                setTimeout(()=>{
                                    this.props.history.push(`/${this.props.school?.slug}/check-payment-sucess`)
                                },2000)
                            })
                        } else {
                            this.setState({ loader: false })
                        }


                    }

                    public async paybyStripeMethod() {
                        const {
                            appContext: { user },

                        } = this.props;
                        this.setState({ loader: true })
                        console.log("this.prrrr", this.state?.upgradeDetails)

                        const paymentData = {
                            "plan_id": this.state?.upgradeDetails?.plan?.id || "",
                            "school_id": this.props.school.id,
                            "user_id": user.id,
                            "addon_id": this.state?.upgradeDetails?.addonId?.length > 0 ? this.state?.upgradeDetails?.addonId : []
                        }
                        const formData: any = new FormData();
                        formData.append('user_id', user.id);
                        formData.append('school_id', this.props.school.id);
                        formData.append('membership_id', this.state?.upgradeDetails?.membership_id || ""  );
                        formData.append('plan_id', this.state?.upgradeDetails?.plan?.id || "");
                        if (this.state?.urlType|| this.state?.upgradeDetails?.onlyBuyAddon === true) {
                            formData.append('type', 'addon');
                        }
                        // data.append('addon_id[]', '2');
                        formData.append('agreements', this.state?.upgradeDetails?.agreement);
                        if (paymentData?.addon_id?.length > 0) {
                            paymentData?.addon_id.map((item: any) => {
                                formData.append('addon_id[]', item);
                            })

                        }
                        console.log("formData", formData)
                        const res: any = await this.buildPost(this, "payment/planUpgradeStripe")(formData)
                        console.log("res?.data", res)
                        if (res?.status && Object.keys(res?.data)?.length > 0) {
                            this.setState({ upgradeDetails: { ...this.state.upgradeDetails, stripeRes: res?.data } }, () => {
                                localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));
                            })
                            this.setState({ loader: false }, () => {
                                window.location.href = res?.data?.payment_url
                            })
                        } else {
                            this.setState({ loader: false })
                        }
                    }

                    public async paybyRenewPlanCheck() {
                        this.setState({ loader: true })
                        console.log("this.prrrr", this.state?.upgradeDetails)
                        const paymentData = {
                            "membership_id": this.state?.upgradeDetails?.memberShipId,
                            "type": 'cheque'
                        }
                        const res: any = await this.buildPut(this, "payment/paybyCheckOrStripe")(paymentData)
                        console.log("res------->", res)
                        if (res.status && Object.keys(res?.data)?.length > 0) {
                            this.setState({ upgradeDetails: { ...this.state.upgradeDetails, paymentRes: res } }, () => {
                                localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));
                            })
                            this.setState({ loader: false }, () => {
                                // this.props.history.push(`/${this.props.school?.slug}/check-payment-sucess`)
                                setTimeout(()=>{
                                    this.props.history.push(`/${this.props.school?.slug}/check-payment-sucess`)
                                },5000)
                            })
                        } else {
                            this.setState({ loader: false })
                        }


                    }
                    public async paybyRenewPlanStripe() {
                        this.setState({ loader: true })
                        const paymentData = {
                            "membership_id": this.state?.upgradeDetails?.memberShipId,
                            "type": 'stripe'
                        }
                        const res: any = await this.buildPut(this, "payment/paybyCheckOrStripe")(paymentData)
                        console.log("res data of stripe------->", res)
                        if (res.status && Object.keys(res?.data)?.length > 0) {
                            this.setState({ upgradeDetails: { ...this.state.upgradeDetails, stripeRes: res?.data } }, () => {
                                localStorage.setItem("upgradeDetails", JSON.stringify(this.state.upgradeDetails));
                            })
                            this.setState({ loader: false }, () => {
                                window.location.href = res?.data?.payment_url
                            })
                        } else {
                            this.setState({ loader: false })
                        }


                    }
                    public declineAgreement() {
                        this.setState({ isAgree: false })

                    }


public formatDateMMDDYYYY = (dateStr?: string) => {
  if (!dateStr){ return "";}
  const date = new Date(dateStr);

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();

  return `${mm}-${dd}-${yyyy}`;
};
                    public render() {
                        const {
                            appContext: { user },

                        } = this.props;
const alreadyAvailableAddonTotal =
  JSON.parse(localStorage.getItem("upgradeDetails") || "{}")
    ?.alreadyAvailableAddonTotal || 0;
const allAddonlist =
  JSON.parse(localStorage.getItem("upgradeDetails") || "{}")
    ?.getAllAddonData || [];
    console.log("allAddonlist===>", allAddonlist);
// Plan Total
    const baseTotal =
  (this.state?.paymentDetails?.total || 0)
  - (this.state?.paymentDetails?.discount_amount || 0)
  + (alreadyAvailableAddonTotal || 0);

const processingFee = (baseTotal * 3) / 100;
const finalTotal = baseTotal + processingFee;

                        const finalDetails = {
                            email: user?.email,
                            firstName: user?.firstName,
                            lastName: user?.lastName,
                            school: this.props.school?.name,
                            plan: this.state?.upgradeDetails?.plan,
                            paymentMethodType: this.state.paymentMethodType,
                            payable: this.state?.urlType==="" && !this.state.upgradeDetails?.onlyBuyAddon ? 
                                this.state?.paymentDetails?.total - this.state.paymentDetails.discount_amount  :
                                (this.state?.paymentDetails?.addon?.reduce((sum: number, item: any) => sum + item.price, 0) || 0) ,
                            type: this.state?.urlType,
                            AlreadyAvailableAddonTotal: alreadyAvailableAddonTotal
                        }
                        const showCondition = "isStripe" in this.state.upgradeDetails

                       
const isPlanUpgrade =
  this.state.urlType === "" &&
  !this.state.upgradeDetails?.onlyBuyAddon;
  
  const addonMessage = `Add-ons renew with your main subscription on the same renewal date
    ${this.formatDateMMDDYYYY(this.state?.paymentDetails?.validUpto)}. Add-ons do not have separate renewal cycles.`;
  const confirmationMessage =
  this.state?.paymentDetails?.isWithinTwoMonths

    ? `You will pay $${this.TwoDecimalFloat(finalTotal)} now for early access.
Your annual renewal on ${this.formatDateMMDDYYYY(
  this.state?.paymentDetails?.validUpto
)}.`
    : `Your annual renewal date is ${this.formatDateMMDDYYYY(
  this.state?.paymentDetails?.validUpto
)}.
You are currently being charged the prorated difference between your current plan and your new plan. Your card will be charged the full amount for your new plan on ${this.formatDateMMDDYYYY(
  this.state?.paymentDetails?.validUpto
)}.`;


                        return (
                              <div>
                {this.state.loader &&<div className="loader-bg-color">
                    <LoadingSpinner />
                    {this.state.showMessage && (
                <div style={{display:"flex",justifyContent:"center"}}>{this.state.showMessage && (
                    <p style={{color: "#fff",  position: 'absolute',
                      top: '42%',
                      fontSize:"30px",
                      paddingLeft:"45px",
                      fontFamily:"'Poppins' !important",
                      zIndex: 1000,}}>We are currently in progress. Please stand by.</p>
                  )}</div>
            )}
                    </div>}
                    {this.state.showUpgradeAlert && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.4)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        backgroundColor: "#fff8d6",
        border: "1px solid #f2c94c",
        padding: "20px",
        borderRadius: "8px",
        width: "420px",
        color: "#6b5500",
        fontSize: "14px",
        lineHeight: "1.5",
        whiteSpace: "pre-line",
      }}
    >
      <strong>Important</strong>

      <p style={{ marginTop: "10px" }}>
        {this.state.upgradeAlertMessage}
      </p>

      <div style={{ textAlign: "right", marginTop: "18px" }}>
        <button
          style={{
            padding: "6px 14px",
            marginRight: "8px",
            background: "#ddd",
            border: "none",
            borderRadius: "4px",
          }}
          onClick={() => this.setState({ showUpgradeAlert: false })}
        >
          Cancel
        </button>

        <button
          style={{
            padding: "6px 14px",
            background: "#f2c94c",
            border: "none",
            borderRadius: "4px",
            fontWeight: 600,
          }}
          onClick={() => {
            this.setState({ showUpgradeAlert: false });
            this.paymentMethodsType(2);
            this.openAgreementModal();
          }}
        >
          Continue
        </button>
      </div>
    </div>
  </div>
)}

                            <Page
                                header={'Purchase Plan'}
                                subtitle={''}
                            >
                                <div>
                                    <div className="container">
                                        <AgreementComponent
                                            openAgreementModal={() => {
                                                this.openAgreementModal()
                                            }}
                                            closeAgreementModal={() => {
                                                this.closeAgreementModal()
                                            }}
                                            acceptAgreement={(pdfFile: any) => {
                                                this.acceptAgreement(pdfFile)
                                            }}
                                            declineAgreement={() => {
                                                this.declineAgreement()
                                            }}
                                            openAgreement={this.state.openAgreement}
                                            details={finalDetails}
                                        />
                                        <div className="purchase-content">
                                            <div className="row purchase-row">
                                                <div className="col-lg-8">
                                                    {Object.keys(this.state?.paymentDetails)?.length > 0 && <div className="purchase-inner-content">
                                                        <div className="purchase-inform check-inform"><h3>Purchase Information</h3></div>

                                                        {this.state.urlType==="" && !this.state.upgradeDetails?.onlyBuyAddon ? (
                                                            // Display full table when urlType is blank
                                                            <>
                                                                {Object?.keys(this.state?.paymentDetails?.plan)?.length > 0 &&  <div className="subscription-fee">
                                                                    <div className="subscription-fee-flex">
                                                                        <div className="sub-yearly">
                                                                            <h4>
                                                                                 Current Plan Charges
                                                                                 <br />
                                                                                 (including selected addons) 
    
                                                                                {/* {this.state?.paymentDetails?.plan?.id === 1 ? "Fee" : "Fees"} <br />
                                                                                ({this.state?.paymentDetails?.plan?.title}/{this.state?.paymentDetails?.plan?.payment_frequency_type.charAt(0).toUpperCase() + this.state?.paymentDetails?.plan?.payment_frequency_type.slice(1)}) */}
                                                                                </h4>
                                                                        </div>
                                                                        <div>
                                                                            <h3>
  ${this.TwoDecimalFloat(
    (this.state?.paymentDetails?.total || 0) + (alreadyAvailableAddonTotal || 0)
  )}
</h3>

                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {/* {this.state?.paymentDetails?.addon?.length > 0 && this.state?.paymentDetails?.addon.map((item: any) => {
                                                                    return (
                                                                        <div className="customizeable" key={item?.id}>
                                                                            <div className="subscription-sub-flex">
                                                                                <div className="sub-custom">
                                                                                    <h4>{item?.title}
                                                                                        <br />
                                                                                        (Add on) </h4>
                                                                                </div>
                                                                                <div>
                                                                                    <h3>${this.TwoDecimalFloat(item?.price)}</h3>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )

                                                                })
                                                                } */}
                                                                {/* { alreadyAvailableAddonTotal > 0 &&

<div className="customizeable">
                                                                     <div className="subscription-sub-flex">
  <div className="sub-custom">
    <h4>
      Previously Purchased Add-ons <br />
      (Now Included at No Extra Cost)
    </h4>

    
  </div>

  <div className="freePrice">
            <h3>
              ${this.TwoDecimalFloat(alreadyAvailableAddonTotal)}
            </h3>
    
          </div>
</div>

                                                                    </div>

                                                                } */}
                                                                {/* {allAddonlist
      ?.filter((addon: any) => addon.is_available)
      .map((addon: any) => (
        <div className="customizeable">
                                                                     <div className="subscription-sub-flex">
        <div className="sub-custom">
          
          <h4>
      {addon.title}
    </h4>
    </div>
            <div>
                <h3>
            ${this.TwoDecimalFloat(addon.price)}
            </h3>
          </div>
       
        
        </div>
        </div>
        ))} */}
      
                                                                {this.state?.paymentDetails?.discount_amount > 0 &&   (
                                                                    <div className="customizeable">
                                                                        <div className="subscription-sub-flex">

                                                                            <div className="sub-custom">
                                                                                <h4>Previous Plan Charges
                                                                        
 </h4>
                                                                            </div>

                                                                            <div>
                                                                                <h3>-${this.TwoDecimalFloat(this.state?.paymentDetails?.discount_amount)}</h3>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* {(
      alreadyAvailableAddonTotal +
      (this.state?.paymentDetails?.discount_amount || 0)
    ) > 0 && (
        <div className="customizeable">
        <div className="subscription-sub-flex">
      <div
        style={{
          background: "#e6f7ee",
          border: "1px solid #2ecc71",
          padding: "10px",
          borderRadius: "6px",
          color: "#1e8449",
          fontWeight: 600,
          width: "100%",
        }}
      >
         You saved $
        {this.TwoDecimalFloat(
          alreadyAvailableAddonTotal +
          (this.state?.paymentDetails?.discount_amount || 0)
        )}
        {" "}from previous payments and add-ons
      </div>
      </div>
      </div>
    )} */}

                                                                <div className="totalprice">
                                                                    <h3>
                                                                        Total amount to pay: $
                                                                        {this.TwoDecimalFloat(
                                                                            this.state?.paymentDetails?.total - this.state?.paymentDetails?.discount_amount + alreadyAvailableAddonTotal
                                                                        )}
                                                                    </h3>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            // Display only addons when urlType has a value
                                                            <>
                                                                {this.state?.paymentDetails?.addon?.length > 0 && this.state?.paymentDetails?.addon.map((item: any) => {
                                                                    return (
                                                                        <div className="customizeable" key={item?.id}>
                                                                            <div className="subscription-sub-flex">
                                                                                <div className="sub-custom">
                                                                                    <h4>{item?.title}
                                                                                        <br />
                                                                                        (Add on) </h4>
                                                                                </div>
                                                                                <div>
                                                                                    <h3>${this.TwoDecimalFloat(item?.price)}</h3>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}

                                                                <div className="totalprice">
                                                                    <h3>
                                                                        Total amount to pay: $
                                                                        {this.TwoDecimalFloat(
                                                                            this.state?.paymentDetails?.addon?.reduce((sum: number, item: any) => sum + item.price, 0) || 0
                                                                        )}
                                                                    </h3>
                                                                </div>
                                                            </>
                                                        )}

                                                        {showCondition ? <>
                                                            {!this.state.upgradeDetails?.isStripe && <div className="continuetosecure"
                                                                onClick={() => {
                                                                    this.paymentMethodsType(1)
                                                                    this.openAgreementModal()
                                                                }}
                                                            >
                                                                {/* <h5>Pay by Check</h5> */}
                                                            </div>}
                                                            {this.state.upgradeDetails?.isStripe && <div>
                                                                <button className="down-invoice" onClick={() => {
                                                                    this.paymentMethodsType(2)
                                                                    this.openAgreementModal()
                                                                }}>
                                                                    Pay by Credit Card 
                                                                </button>
                                                            </div>}
                                                        </> : <>
                                                            <div className="continuetosecure"
                                                                // onClick={() => {
                                                                //     this.paymentMethodsType(1)
                                                                //     this.openAgreementModal()
                                                                // }}
                                                            >
                                                                {/* <h5>Pay by Check</h5> */}
                                                            </div>
                                                            <div>
                                                                <button className="down-invoice"  
//                                                                 onClick={() => {
    // if (isPlanUpgrade) {
    //   // ✅ plan → plan upgrade
    //   const isConfirmed = window.confirm(confirmationMessage);
    //   if (!isConfirmed) {return;}
    // }

//     // ✅ direct proceed for only addon
//     this.paymentMethodsType(2);
//     this.openAgreementModal();
//   }}

onClick={() => {
    if (isPlanUpgrade && this.state.oldPlanDetails?.plan?.id !== 1) {
  this.setState({
    showUpgradeAlert: true,
    upgradeAlertMessage: confirmationMessage,
  });
}else if (this.state.upgradeDetails?.onlyBuyAddon === true ||
  this.state.urlType !== ""){
    this.setState({
    showUpgradeAlert: true,
    upgradeAlertMessage: addonMessage,
  });
}else{
    this.paymentMethodsType(2);
    this.openAgreementModal();
}
}}
  >
                                                                    Pay by Credit Card 
                                                                </button>
                                                            </div>
                                                        </>}
    {/* // added note for 3% processing fee */}
                                                        <p className="creditText">
    Please note that payments made by credit card are subject to an industry-standard 3% processing fee. 
    {/* Total with fee: $
    {!this.state.urlType ? 
        this.TwoDecimalFloat(
            (this.state?.paymentDetails?.total-this.state?.paymentDetails?.discount_amount+ this.state?.oldPlanDetails?.addonPrice) * 1.03
        ) :
        this.TwoDecimalFloat(
            (this.state?.paymentDetails?.addon?.reduce((sum: number, item: any) => sum + item.price, 0) || 0) * 1.03
        )
    }  */}

    {/* (Base: ${this.TwoDecimalFloat(this.state?.paymentDetails?.total-this.state?.paymentDetails?.discount_amount)} + Fee: $
    {this.TwoDecimalFloat((this.state?.paymentDetails?.total-this.state?.paymentDetails?.discount_amount) * 0.03)}) */}
</p>
{/* <p style={{ marginTop: "15px", color: "#cc0000", fontSize: "16px" }}>
    * You are paying the difference to access these features now. Your subscription will still renew on at the full new plan price.
</p> */}
                                                    </div>}

                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                </div>
                               
                            </Page>
                            </div>
                        );
                    }


                }

            )
        )
    )
);



// WEBPACK FOOTER //
// ./src/pages/director/upgradeSubscription/purchasePlan.tsx